export default __webpack_public_path__ + "static/media/NoResults.f7c4dbd3.svg";